module.exports = __webpack_public_path__ + "assets/iron-worker.svg?559fd27a54c8ec5f0c77f40e2067886e";